'use client'

import { useEffect } from 'react'
import { trackException } from '@/src/lib/appInsights'
import { logger } from '@/src/lib/logger'
import { ErrorState } from '@/src/components/ErrorState'

/**
 * Error Boundary de segmento (Next.js App Router).
 *
 * Captura erros em qualquer rota dentro de `src/app/`, mantendo o root layout
 * (MenuLateral, Header, etc) visível. Para erros que afetam o root layout
 * em si, ver `global-error.tsx`.
 *
 * Task #193 / F13.6.
 */

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    trackException(error, {
      source: 'AppRouterErrorBoundary',
      digest: error.digest ?? '',
      url: typeof window !== 'undefined' ? window.location.href : '',
    })
    logger.error('Next.js segment error caught', error, {
      digest: error.digest ?? '',
    })
  }, [error])

  return (
    <ErrorState
      title="Erro ao carregar esta página"
      error={error}
      onRetry={reset}
      source="AppRouterErrorBoundary"
    />
  )
}
